import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '../ui';
import { DesignerState } from './DesignerFlow';
import { CheckIcon } from 'lucide-react';
interface Props {
  data: DesignerState;
  updateData: (data: Partial<DesignerState>) => void;
  onNext: () => void;
  onBack: () => void;
}
export function Step4Learning({
  data,
  updateData,
  onNext,
  onBack
}: Props) {
  const learningThemes = ['Leadership Reset', 'Team Trust', 'Communication Under Pressure', 'Habits and Execution', 'Wellness and Energy', 'Customer Excellence', 'Strategic Clarity', 'Money Mindset', 'Manager Effectiveness', 'Post-Retreat Accountability'];
  const wellnessActivities = ['Beach walk', 'Breathwork', 'Morning movement', 'Reflection time', 'Spa / recovery', 'Digital detox', 'Nutrition focus', 'Sleep reset', 'Outdoor team activity', 'Quiet solo time'];
  const toggleItem = (list: 'learningThemes' | 'wellnessActivities', item: string) => {
    const currentList = data[list];
    if (currentList.includes(item)) {
      updateData({
        [list]: currentList.filter(i => i !== item)
      });
    } else {
      updateData({
        [list]: [...currentList, item]
      });
    }
  };
  const isValid = data.learningThemes.length > 0 || data.wellnessActivities.length > 0;
  const renderGrid = (title: string, items: string[], listKey: 'learningThemes' | 'wellnessActivities') => <div className="mb-10" data-id="element-2536">
      <h3 className="text-lg font-bold text-brand-navy mb-4" data-id="element-2537">{title}</h3>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-3" data-id="element-2538">
        {items.map(item => {
        const isSelected = data[listKey].includes(item);
        return <button key={item} onClick={() => toggleItem(listKey, item)} className={`text-left p-3 rounded-xl border transition-all duration-200 flex items-start gap-3 ${isSelected ? 'border-brand-teal bg-brand-teal/5 ring-1 ring-brand-teal' : 'border-slate-200 hover:border-brand-teal/50 hover:bg-slate-50'}`} data-id="element-2539">
              <div className={`mt-0.5 w-4 h-4 rounded flex-shrink-0 flex items-center justify-center border ${isSelected ? 'bg-brand-teal border-brand-teal text-white' : 'border-slate-300 bg-white'}`} data-id="element-2540">
                {isSelected && <CheckIcon className="w-3 h-3" data-id="element-2541" />}
              </div>
              <span className={`text-sm font-medium leading-tight ${isSelected ? 'text-brand-navy' : 'text-slate-600'}`} data-id="element-2542">
                {item}
              </span>
            </button>;
      })}
      </div>
    </div>;
  return <motion.div initial={{
    opacity: 0,
    x: 20
  }} animate={{
    opacity: 1,
    x: 0
  }} className="max-w-3xl mx-auto bg-white rounded-2xl shadow-sm border border-slate-200 p-8 md:p-12" data-id="element-2543">
      <h1 className="text-3xl font-bold text-brand-navy mb-8" data-id="element-2544">
        Choose your learning and wellness themes.
      </h1>

      {renderGrid('Learning Themes', learningThemes, 'learningThemes')}
      {renderGrid('Wellness Activities', wellnessActivities, 'wellnessActivities')}

      <div className="mb-8" data-id="element-2545">
        <label className="block text-sm font-semibold text-slate-700 mb-2" data-id="element-2546">
          Any constraints or preferences we should know?
        </label>
        <textarea value={data.constraints} onChange={e => updateData({
        constraints: e.target.value
      })} className="w-full px-4 py-3 rounded-xl border border-slate-300 focus:ring-2 focus:ring-brand-teal focus:border-brand-teal outline-none transition-all min-h-[100px] resize-y" placeholder="e.g. Half the team is remote, budget is tight for external speakers..." data-id="element-2547" />
      </div>

      <div className="mt-10 pt-6 border-t border-slate-100 flex justify-between items-center" data-id="element-2548">
        <Button variant="ghost" onClick={onBack} data-id="element-2549">
          Back
        </Button>
        <Button variant="accent" size="lg" onClick={onNext} disabled={!isValid} data-id="element-2550">
          Generate Blueprint
        </Button>
      </div>
    </motion.div>;
}